import React, { useState } from "react";
import { Avatar, Box, Button, Popover, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  getClienteAvatarColor,
  getClienteInitials,
  getPedidoCliente,
} from "./pedidosVentaUtils";

export const InicialesAvatar = ({
  name,
  roleLabel = "",
  size = 32,
  colorSeed = "",
  actionLabel,
  onAction,
}) => {
  const [anchor, setAnchor] = useState(null);
  const label = String(name || "").trim();
  const initials = getClienteInitials(label);
  const color = getClienteAvatarColor(`${label}${colorSeed}`);

  if (!label) return null;

  return (
    <>
      <Avatar
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(event.currentTarget);
        }}
        sx={{
          width: size,
          height: size,
          fontSize: size > 30 ? "0.72rem" : "0.62rem",
          fontWeight: 800,
          bgcolor: alpha(color, 0.16),
          color,
          border: "1px solid",
          borderColor: alpha(color, 0.35),
          cursor: "pointer",
        }}
      >
        {initials}
      </Avatar>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClick={(event) => event.stopPropagation()}
      >
        <Box sx={{ p: 1.25, minWidth: 200, maxWidth: 320 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar
              sx={{
                width: 36,
                height: 36,
                fontWeight: 800,
                fontSize: "0.78rem",
                bgcolor: color,
                color: "#fff",
              }}
            >
              {initials}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              {roleLabel ? (
                <Typography variant="caption" color="text.secondary" fontWeight={700}>
                  {roleLabel}
                </Typography>
              ) : null}
              <Typography fontWeight={800} sx={{ lineHeight: 1.25, fontSize: "0.88rem" }}>
                {label}
              </Typography>
            </Box>
          </Stack>
          {onAction && actionLabel ? (
            <Button
              fullWidth
              size="small"
              sx={{ mt: 1.1, textTransform: "none", fontWeight: 800 }}
              onClick={() => {
                onAction();
                setAnchor(null);
              }}
            >
              {actionLabel}
            </Button>
          ) : null}
        </Box>
      </Popover>
    </>
  );
};

const ClienteAvatar = ({ row, size = 32, onPaintCliente }) => (
  <InicialesAvatar
    name={getPedidoCliente(row)}
    roleLabel="Cliente"
    size={size}
    actionLabel={onPaintCliente ? "Pintar líneas de este cliente" : undefined}
    onAction={onPaintCliente ? () => onPaintCliente(row) : undefined}
  />
);

export const RepAvatar = ({ row, size = 32 }) => (
  <InicialesAvatar
    name={String(row?.REPALIAS || "").trim()}
    roleLabel="Account Manager"
    size={size}
    colorSeed="|rep"
  />
);

export default ClienteAvatar;
